export const LOCAL_STORAGE_KEY_CONSTANTS = {
  THEME: 'THEME',
  USER_INFORMATION: 'USER_INFORMATION',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  LATEST_VERIFICATION_CODE: 'LATEST_VERIFICATION_CODE',
}
